import React from 'react'
import { useRouter } from 'next/router'

import { Text } from '@wartek-id/text-v1'

import { PENGELOLAAN_KINERJA_PENILIK_PEGAWAI_PATH } from 'app/KinerjaShared/constants/path'
import {
  TableBody,
  TableHeader,
  TableHeaderItem,
  TablePelaksanaanKinerja,
  TableRow,
  TableRowItem,
} from 'app/KinerjaShared/components/TablePelaksanaanKinerja'
import { CardSummary } from 'app/KinerjaPSPegawaiPage/components/CardSummary'
import { DialogConfirmation } from 'app/KinerjaPSPegawaiPage/components/DialogConfirmation'

import type { Perencanaan } from 'types/kinerja-penilik-pegawai'

const TABLE_COLUMNS = [
  {
    name: 'No.',
    className: 'w-1/12',
  },
  {
    name: 'Aspek',
    className: 'w-3/12 pl-0',
  },
  {
    name: 'Indikator Perilaku',
    className: 'w-4/12 pl-0',
  },
  {
    name: 'Ekspektasi Khusus Pimpinan',
    className: 'w-4/12 pl-0',
  },
]

type TDialogChangePerilakuKerjaProps = {
  isOpen: boolean
  onClose: () => void
  onConfirm: () => void
}
const DialogChangePerilakuKerja: React.FC<TDialogChangePerilakuKerjaProps> = ({
  isOpen,
  onClose,
  onConfirm,
}) => {
  return (
    <DialogConfirmation
      isOpen={isOpen}
      autoFocus={false}
      returnFocus={false}
      size="sm"
      title="Ubah Perilaku Kerja?"
      description="Setelah diubah, pastikan Anda lanjut mengajukan Perencanaan."
      ctaConfirm="Ke Perilaku Kerja"
      onClickConfirm={onConfirm}
      onClickCancel={onClose}
    />
  )
}

type SectionPerilakuKerjaProps = {
  data: Perencanaan
  showRightAction?: boolean
}
export const SectionPerilakuKerja: React.FC<SectionPerilakuKerjaProps> = ({
  data,
  showRightAction = false,
}) => {
  const router = useRouter()
  const [isDialogOpen, setIsDialogOpen] = React.useState<boolean>(false)

  const parsedJSON = React.useMemo(() => {
    try {
      const parsed = JSON.parse(data?.perilakuKerjaValues)
      return typeof parsed === 'object' ? parsed : [] // return empty array if parsed is not an object
    } catch (error) {
      return []
    }
  }, [data?.perilakuKerjaValues])

  return (
    <>
      <CardSummary
        title="Perilaku Kerja"
        {...(showRightAction && {
          onChangeClicked: () => setIsDialogOpen(true),
        })}
      >
        <div className="pb-2 bg-white rounded-b-md">
          {/* Table */}
          <TablePelaksanaanKinerja className="!mt-0">
            <TableHeader>
              {TABLE_COLUMNS.map(({ name, className }, index) => (
                <TableHeaderItem
                  key={`table-row-${index}`}
                  className={className}
                >
                  <Text variant="body" color="default" className="!font-bold">
                    {name}
                  </Text>
                </TableHeaderItem>
              ))}
            </TableHeader>
            <TableBody>
              {parsedJSON.map(({ aspek, indikator, ekspektasi }, index) => (
                <TableRow
                  key={`table-row-${index}`}
                  className="bg-white last-of-type:border-b-0"
                >
                  <TableRowItem className="align-middle">
                    <Text color="default" className="overflow-wrap-anywhere">
                      {index + 1}
                    </Text>
                  </TableRowItem>
                  <TableRowItem className="pl-0 align-middle">
                    <Text color="default" className="overflow-wrap-anywhere">
                      {aspek}
                    </Text>
                  </TableRowItem>
                  <TableRowItem className="pl-0 align-middle">
                    <Text color="default" className="overflow-wrap-anywhere">
                      {indikator}
                    </Text>
                  </TableRowItem>
                  <TableRowItem className="pl-0 align-middle">
                    <Text color="default" className="overflow-wrap-anywhere">
                      {ekspektasi}
                    </Text>
                  </TableRowItem>
                </TableRow>
              ))}
            </TableBody>
          </TablePelaksanaanKinerja>
        </div>
      </CardSummary>

      <DialogChangePerilakuKerja
        isOpen={isDialogOpen}
        onConfirm={() => {
          router.push(
            `${PENGELOLAAN_KINERJA_PENILIK_PEGAWAI_PATH}/perencanaan/perilaku-kerja`
          )
          setIsDialogOpen(false)
        }}
        onClose={() => {
          setIsDialogOpen(false)
        }}
      />
    </>
  )
}
